import React from 'react';
import { Button, Card, Badge } from './ui';

interface Campaign {
  id: string;
  title: string;
  category: string;
  extractions_remaining: number;
}

interface CampaignCardProps {
  campaign: Campaign;
  onResume: (id: string) => void;
  onExport: (id: string) => void;
  onDelete: (id: string) => void;
}

export function CampaignCard({ campaign, onResume, onExport, onDelete }: CampaignCardProps) {
  const getExportBadgeVariant = () => campaign.extractions_remaining > 0 ? 'success' : 'error';

  return (
    <Card style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 'var(--space-3)' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-2)' }}>
        <strong className="campaign-title">{campaign.title}</strong>
        <Badge variant="info">
          {campaign.category}
        </Badge>
        <Badge variant={getExportBadgeVariant()}>
          Exports left: {campaign.extractions_remaining}/2
        </Badge>
      </div>
      <div style={{ display: 'flex', gap: 'var(--space-2)' }}>
        <Button
          size="sm"
          onClick={() => onResume(campaign.id)}
        >
          Resume
        </Button>
        <Button
          size="sm"
          disabled={campaign.extractions_remaining <= 0}
          onClick={() => onExport(campaign.id)}
        >
          Export Story
        </Button>
        <Button
          size="sm"
          variant="destructive"
          onClick={() => onDelete(campaign.id)}
        >
          Delete
        </Button>
      </div>
    </Card>
  );
}
